import { render, staticRenderFns } from "./ESituacaoAulaEletiva.vue?vue&type=template&id=fddd36bc"
import script from "./ESituacaoAulaEletiva.vue?vue&type=script&lang=js"
export * from "./ESituacaoAulaEletiva.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports